const URL_BASE=process.env.REACT_APP_API;

export const URL_DASHBOARD=`${URL_BASE}/dashboard`;